/* eslint-disable camelcase */
export interface Position {
  x: number;
  y: number;
  z?: number;
}

export interface Rotation extends Position {
  w: number;
}

export interface SweepPath {
  id: string;
  position: Position;
  rotation: Rotation;
  next?: SweepPath;
}

export enum SweepType {
  Text = 'text',
  Image = 'image',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  None = 'none',
  Panorama = 'panorama',
  GreenScreen = 'green_screen',
}

export interface Sweep {
  model_id: string;
  uuid: string;
  sweep_uuid: string;
  position: Position;
  floor_position: Position;
  index: number;
  floor_index: number;
  room_index: number;
  rotation: Rotation;
  neighbors: number[];
  tags: string[];
  sweep_name: string;
  alignment_type: string;
  placement: string;
}
